import { prepareFormDataId } from '@/utils/form/prepareFormDataId'
import { prepareFormDataIdArray } from '@/utils/form/prepareFormDataIdArray'

function prepareProjectPtoJobFormData (data) {
  const keyList = [
    'job_type',
    'measure_unit',
    'executor',
    'executor_contract',
    'treaty'
  ]

  if (data.is_mol) {
    data.executor_contract = null
    data.treaty = null
    data.general_contract = null
  } else {
    data.executor = null
  }

  return prepareFormDataId(data, keyList)
}

function prepareProjectPtoSupplyFormData (data) {
  const keyList = [
    'mol'
  ]

  const prepareFormData = prepareFormDataId(data, keyList)

  const keyListForIdArray = ['jobs']

  return prepareFormDataIdArray(prepareFormData, keyListForIdArray)
}

function prepareProjectPtoKMDFormData (data) {
  const keyList = [
    'developer'
  ]

  return prepareFormDataId(data, keyList)
}

function prepareProjectPtoCMKFormData (data) {
  const keyList = [
    'responsible',
    'measure_unit'
  ]

  return prepareFormDataId(data, keyList)
}

function prepareProjectPtoCMOFormData (data) {
  const keyList = [
    'responsible',
    'measure_unit'
  ]

  return prepareFormDataId(data, keyList)
}

function prepareProjectPtoPVHFormData (data) {
  const keyList = [
    'responsible',
    'measure_unit'
  ]

  return prepareFormDataId(data, keyList)
}

function prepareProjectPtoBRUFormData (data) {
  const keyList = [
    'responsible',
    'measure_unit'
  ]

  return prepareFormDataId(data, keyList)
}

function prepareProjectPtoNomenclatureFormData (data) {
  const keyList = [
    'type',
    'measure_unit',
    'standard'
  ]

  return prepareFormDataId(data, keyList)
}

function prepareProjectPtoPPRFormData (data) {
  const keyList = [
    'developer',
    'mol'
  ]

  return prepareFormDataId(data, keyList)
}

export {
  prepareProjectPtoJobFormData,
  prepareProjectPtoSupplyFormData,
  prepareProjectPtoKMDFormData,
  prepareProjectPtoCMKFormData,
  prepareProjectPtoCMOFormData,
  prepareProjectPtoPVHFormData,
  prepareProjectPtoBRUFormData,
  prepareProjectPtoNomenclatureFormData,
  prepareProjectPtoPPRFormData
}
